import type { ReactNode } from 'react';
import { PoweredBy } from '../../ui/PoweredBy';
import { Wordmark } from '../../ui/Wordmark';
import styles from './AuthLayout.module.css';

const FACTS = [
  'Cada conversación tiene una persona responsable, y solo ella responde.',
  'Estados de envío reales: aceptado, entregado, leído o fallido.',
  'La ventana de 24 horas y las plantillas aprobadas, siempre a la vista.',
];

/** Entrada y cambio de contraseña: marca a la izquierda, formulario a la derecha (arriba y abajo en móvil). */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.page}>
      <aside className={styles.brand} aria-label="Hilo">
        <Wordmark tone="inverse" size="lg" />
        <div className={styles.pitch}>
          <p className={styles.eyebrow}>Corp Salex · Atención de publicidad</p>
          <p className={styles.headline}>Cada cliente, en un solo hilo.</p>
          <p className={styles.lead}>
            Los mensajes de Facebook, Instagram y WhatsApp llegan a una bandeja compartida, y todo el equipo ve quién atiende cada conversación.
          </p>
          <ul className={styles.facts}>
            {FACTS.map((fact) => <li key={fact}>{fact}</li>)}
          </ul>
        </div>
        {/* Los nudos están calculados sobre la curva de la costura (puntos exactos del trazado). */}
        <svg className={styles.thread} viewBox="0 0 800 225" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
          <path className={styles.basting} d="M-40 120 C 120 90, 220 190, 400 165 S 650 80, 840 110" />
          <path className={styles.seam} d="M-40 190 C 110 150, 200 40, 360 60 S 560 210, 680 150 S 780 40, 840 30" />
          <circle className={styles.knotOpen} cx="174.7" cy="93.7" r="6.5" />
          <circle className={styles.knot} cx="360" cy="60" r="8.5" />
          <circle className={styles.knotOpen} cx="535" cy="135" r="6.5" />
          <circle className={styles.knot} cx="680" cy="150" r="6" />
        </svg>
        <div className={styles.foot}>
          <p>Uso interno del personal de Corp Salex</p>
          <PoweredBy tone="inverse" />
        </div>
      </aside>
      <main className={styles.panel}>
        <div className={styles.form}>
          {/* Solo en pantallas estrechas: el logo de Hilo en lugar del panel de marca. */}
          <div className={styles.mobileMark}><Wordmark size="lg" /></div>
          {children}
          <div className={styles.mobileCredit}><PoweredBy /></div>
        </div>
      </main>
    </div>
  );
}
